import { render, staticRenderFns } from "./ChooseBase.vue?vue&type=template&id=cc49f112&scoped=true&"
import script from "./ChooseBase.vue?vue&type=script&lang=js&"
export * from "./ChooseBase.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBase.vue?vue&type=style&index=0&id=cc49f112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc49f112",
  null
  
)

export default component.exports